import { SlideAction, SlideHideConditionType, SlideHidePageCondition, TutorialSlide, UserTutorialStatusType } from "../../tutorial.models";

export const PATIENT_SLIDE_NAV: TutorialSlide[] = [
    {
        key: 'Inviting',
        // title: 'Learn How to use MedicAI ',
        messages: [{ text: "Click on the video above to learn how add patients to MedicAI!" }],
        videoUrl: 'https://www.youtube.com/watch?v=IUjoxO2C1zI',
        thumbnailUrl: 'assets/patient-inviting-thumbnail.png',
        tutorialStatusType: UserTutorialStatusType.INVITING,
        hideDoNotShowAgain: true,
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE
            },
        ],
        hideConditions: [
            { condition: SlideHidePageCondition.INVITING_SLIDE_SEEN, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Patient Admitting and Discharging',
        // title: 'Learn How to use MedicAI ',
        messages: [{ text: "Click on the video above to learn how to use your AI assistant for admitting and discharging patients!" }],
        videoUrl: 'https://www.youtube.com/watch?v=1N690PSxChg',
        thumbnailUrl: 'assets/patient-admitting-thumbnail.png',
        tutorialStatusType: UserTutorialStatusType.DISCHARGING,
        hideDoNotShowAgain: true,
        actions: [
            {
                text: 'Close',
                color: 'primary',
                actionName: SlideAction.CLOSE_TUTORIAL
            },
        ],
        hideConditions: [
            { condition: SlideHidePageCondition.ADMITTING_SLIDE_SEEN, type: SlideHideConditionType.OR },
        ],
    },
];